import * as React from 'react';
import { useIntl } from 'react-intl';
import { useSetRecoilState } from 'recoil';
import { IDynamicTableState } from '../../../interfaces/tables';
import { setTableRowHeight, tablesAtom } from '../../../store/recoil/TableState';

interface IComponentProps {
  tableName: string;
  rowHeight: boolean;
}

export default function TableRowHeight({ ...props }: IComponentProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const setTables = useSetRecoilState<IDynamicTableState>(tablesAtom);

  const handleSetRowHeight = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    setTables((oldState) =>
      setTableRowHeight(oldState, {
        name: props.tableName,
        rowHeight: props.rowHeight !== true,
      })
    );
  };

  return (
    <div className="mb-1 d-inline-block">
      <a
        href="#"
        data-cy={`table-row-height-${!props.rowHeight ? 'max' : 'min'}`}
        title={
          !props.rowHeight ? f({ id: 'table.row.height.max' }) : f({ id: 'table.row.height.min' })
        }
        style={{ backgroundColor: '#fff', padding: '5px' }}
        className="e-button ml-xs text-gray"
        onClick={handleSetRowHeight}
      >
        <i
          className={
            props.rowHeight !== true // tslint:disable-line
              ? 'cmd-icon cmd-icon-expand-rows position-relative top-1 fs-5'
              : 'cmd-icon cmd-icon-collapse-rows position-relative top-1 fs-5'
          }
        />
      </a>
    </div>
  );
}
